"use strict";

exports.__esModule = true;
exports.DeviceConnectivityElement = DeviceConnectivityElement;
var _isEmpty2 = _interopRequireDefault(require("ramda/src/isEmpty"));
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _hasPath2 = _interopRequireDefault(require("ramda/src/hasPath"));
var _react = _interopRequireWildcard(require("react"));
var _DataTable = require("../../Core/DataTable/DataTable");
var _DeviceConnectivitySubscription = require("../../Device/DeviceConnectivitySubscription");
var _DeviceContext = require("../../Device/DeviceContext");
var _common = require("../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var hasDestination = function hasDestination(doc) {
  return doc && doc.destination;
};
var hostPath = ["url", "domain"];
var portPath = ["url", "port"];
var toTitleCase = function toTitleCase(str) {
  return str.split(" ").map(function (w) {
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(" ");
};
function handleSubscriptionData(doc, setState, entityFormatter) {
  if (hasDestination(doc)) {
    var _setState;
    setState((_setState = {}, _setState[doc.destination] = {
      entity: toTitleCase(entityFormatter(doc)),
      host: (0, _hasPath2["default"])(hostPath, doc) ? (0, _path2["default"])(hostPath, doc) : "",
      port: (0, _hasPath2["default"])(portPath, doc) ? (0, _path2["default"])(portPath, doc) : "",
      status: toTitleCase(doc.status)
    }, _setState));
  }
}
function computeColumnWidths(_ref) {
  var entityRelativeWidth = _ref.entityRelativeWidth,
    hostRelativeWidth = _ref.hostRelativeWidth,
    portRelativeWidth = _ref.portRelativeWidth;
  return {
    entity: entityRelativeWidth / 100,
    host: hostRelativeWidth / 100,
    port: portRelativeWidth / 100,
    status: 1 - (entityRelativeWidth + hostRelativeWidth + portRelativeWidth) / 100
  };
}
function DeviceConnectivityElement(props) {
  var showAgentStatus = props.showAgentStatus,
    showAdapterStatus = props.showAdapterStatus,
    showDataSourceStatus = props.showDataSourceStatus;
  var _useState = (0, _react.useState)({}),
    agentStatus = _useState[0],
    setAgentStatus = _useState[1];
  var _useState2 = (0, _react.useState)({}),
    adapterStatus = _useState2[0],
    setAdapterStatus = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    dataSourceStatus = _useState3[0],
    setDataSourceStatus = _useState3[1];
  function handleAgentStatus(doc) {
    handleSubscriptionData(doc, setAgentStatus, function (d) {
      return "Agent " + (d.agent_name || "");
    });
  }
  function handleAdapterStatus(doc) {
    handleSubscriptionData(doc, setAdapterStatus, function (d) {
      return "Adapter " + d.adapter_type + " " + d.adapter;
    });
  }
  function handleDataSourceStatus(doc) {
    handleSubscriptionData(doc, setDataSourceStatus, function (d) {
      return "Data Source " + d.device;
    });
  }
  var isValid = !(0, _isEmpty2["default"])(agentStatus) || !(0, _isEmpty2["default"])(adapterStatus) || !(0, _isEmpty2["default"])(dataSourceStatus);
  var getTableData = function getTableData() {
    return Object.values(Object.assign({}, showAgentStatus ? agentStatus : {}, showAdapterStatus ? adapterStatus : {}, showDataSourceStatus ? dataSourceStatus : {}));
  };
  var columnWidths = computeColumnWidths(props);
  var columns = ["entity", "host", "port", "status"].map(function (c) {
    return {
      id: c,
      name: toTitleCase(c),
      width: columnWidths[c] * props.width,
      type: c,
      enableSorting: false
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": "DeviceConnectivityElement.div"
    }, (0, _common.getWidgetInteractionProps)(props)), showAgentStatus ? /*#__PURE__*/_react["default"].createElement(_DeviceConnectivitySubscription.DeviceConnectivitySubscription, {
      "data-testid": "DeviceConnectivityElement.agentStatusSubscription",
      heartbeatName: "agent_status",
      entity: {
        device: device.uuid
      },
      onData: handleAgentStatus
    }, function () {
      return null;
    }) : null, showAdapterStatus ? /*#__PURE__*/_react["default"].createElement(_DeviceConnectivitySubscription.DeviceConnectivitySubscription, {
      "data-testid": "DeviceConnectivityElement.adapterStatusSubscription",
      heartbeatName: "adapter_status",
      entity: {
        device: device.uuid,
        adapter_name: "*"
      },
      onData: handleAdapterStatus
    }, function () {
      return null;
    }) : null, showDataSourceStatus ? /*#__PURE__*/_react["default"].createElement(_DeviceConnectivitySubscription.DeviceConnectivitySubscription, {
      "data-testid": "DeviceConnectivityElement.dataSourceStatusSubscription",
      heartbeatName: "data_source_status",
      entity: {
        device: device.uuid,
        data_source_name: "*"
      },
      onData: handleDataSourceStatus
    }, function () {
      return null;
    }) : null, isValid ? /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, _extends({
      "data-testid": "DeviceConnectivityElement.dataTable",
      overFetchAll: false,
      enablePagination: false,
      defaultPageSize: 10,
      columns: columns,
      data: getTableData()
    }, (0, _common.getWidgetPositionProps)(props), {
      style: Object.assign({}, (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetColorProps)(props)),
      allowCustomColumnWidth: true
    })) : null);
  });
}